<template>
  <teleport to="#form">
    <div class="base" v-show="showDialog">
      <div class="overlay" v-show="showDialog" @click="$emit('close')"></div>
      <div class="content" v-show="showDialog">
        <h2 class="font-bold" v-if="update_mode">タスクの更新</h2>
        <h2 class="font-bold" v-else>タスクの追加</h2>

        <div class="my-1">
          <label class="text-xs">担当者:</label>
          <input class="text-xs border rounded-lg px-4 py-2" :value="form.worker_name" @input="$emit('change', { field: 'worker_name', value: $event.target.value })" />
        </div>

        <div class="my-1">
          <label class="text-xs">業務形態:</label>
          <input class="text-xs border rounded-lg px-4 py-2" :value="form.name" @input="$emit('change', { field: 'name', value: $event.target.value })" />
          <div v-if="errors && errors.name" class="text-red-500 text-xs mt-1">{{ errors.name }}</div>
        </div>

        <div class="my-1 flex items-center">
          <label class="text-xs">就業日:</label>
<!--          <input class="text-xs border rounded-lg px-4 py-2" :value="form.task_date" type="date" @input="$emit('change', { field: 'task_date', value: $event.target.value })" />-->
          <Datepicker
              :model-value="form['task_date']"
              @update:model-value="handleDateChange"
              date-picker
              locale="ja"
              class="text-xs"
              auto-apply
              :enable-time-picker="false"
              style="width: 150px;"
              :clearable="false"
              :format="formatDate"
          />
          <div v-if="errors && errors.task_date" class="text-red-500 text-xs mt-1">{{ errors.task_date }}</div>
        </div>

        <div class="my-1">
          <label class="text-xs">開始時間:</label>
          <Datepicker
              :model-value="startTime"
              @update:model-value="(value) => handleTimeChange(value, 'start_time')"
              time-picker
              :is-24="true"
              placeholder="時間を選択してください"
              class="text-xs"
              :action-row="{ showCancel: true, showSelect: true, showPreview: false }"
              cancel-text="キャンセル"
              select-text="選択"
          />
          <div v-if="errors && errors.start_time" class="text-red-500 text-xs mt-1">{{ errors.start_time }}</div>
        </div>

        <div class="my-1">
          <label class="text-xs">完了時間:</label>
          <Datepicker
              :model-value="endTime"
              @update:model-value="(value) => handleTimeChange(value, 'end_time')"
              time-picker
              :is-24="true"
              placeholder="時間を選択してください"
              class="text-xs"
              :action-row="{ showCancel: true, showSelect: true, showPreview: false }"
              cancel-text="キャンセル"
              select-text="選択"
          />
          <div v-if="errors && errors.end_time" class="text-red-500 text-xs mt-1">{{ errors.end_time }}</div>
        </div>

        <div class="my-1">
          <label class="text-xs">休憩開始:</label>
          <Datepicker
              :model-value="breakStartTime"
              @update:model-value="(value) => handleTimeChange(value, 'break_start_time')"
              time-picker
              :is-24="true"
              placeholder="時間を選択してください"
              class="text-xs"
              :action-row="{ showCancel: true, showSelect: true, showPreview: false }"
              cancel-text="キャンセル"
              select-text="選択"
          />
          <div v-if="errors && errors.break_start_time" class="text-red-500 text-xs mt-1">{{ errors.break_start_time }}</div>
        </div>

        <div class="my-1">
          <label class="text-xs">休憩終了:</label>
          <Datepicker
              :model-value="breakEndTime"
              @update:model-value="(value) => handleTimeChange(value, 'break_end_time')"
              time-picker
              :is-24="true"
              placeholder="時間を選択してください"
              class="text-xs"
              :action-row="{ showCancel: true, showSelect: true, showPreview: false }"
              cancel-text="キャンセル"
              select-text="選択"
          />
          <div v-if="errors && errors.break_end_time" class="text-red-500 text-xs mt-1">{{ errors.break_end_time }}</div>
        </div>

        <div v-if="update_mode" class="flex items-center justify-between">
          <button @click="$emit('update')" class="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-lg text-xs flex items-center">
            <svg class="w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
            <span class="text-xs font-bold text-white">タスクを更新</span>
          </button>
          <button @click="$emit('delete', form.id)" class="bg-red-500 hover:bg-red-700 text-white py-2 px-4 rounded-lg flex items-center ml-2">
            <svg class="w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
            <span class="text-xs font-bold text-white">タスクを削除</span>
          </button>
        </div>
        <div v-else>
          <button @click="$emit('save')" class="bg-indigo-500 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded-lg flex items-center">
            <svg class="w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
            <span class="font-bold text-xs">タスクを追加する</span>
          </button>
        </div>
        <div v-if="apiErrorMsg" class="text-red-500 text-xs mt-1">{{ apiErrorMsg }}</div>
      </div>
      <div v-if="loading" class="spinner-overlay"><div class="spinner"></div></div>
    </div>
  </teleport>
</template>

<script>
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

export default {
  name: 'CTimeEditForm',
  props: {
    showDialog: { type: Boolean, required: true },
    update_mode: { type: Boolean, required: true },
    form: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
    apiErrorMsg: { type: String, default: '' },
    loading: { type: Boolean, default: false }
  },
  components: { Datepicker },
  emits: ['save', 'update', 'delete', 'close', 'change'],
  computed: {
    startTime() {
      if (!this.form.start_time) return null;

      // Convert HH:MM format to time object
      const [hours, minutes] = this.form.start_time.split(':');
      return {
        hours: parseInt(hours, 10),
        minutes: parseInt(minutes, 10)
      };
    },
    endTime() {
      if (!this.form.end_time) return null;

      // Convert HH:MM format to time object
      const [hours, minutes] = this.form.end_time.split(':');
      return {
        hours: parseInt(hours, 10),
        minutes: parseInt(minutes, 10)
      };
    },
    breakStartTime() {
      if (!this.form.break_start_time) return null;

      // Convert HH:MM format to time object
      const [hours, minutes] = this.form.break_start_time.split(':');
      return {
        hours: parseInt(hours, 10),
        minutes: parseInt(minutes, 10)
      };
    },
    breakEndTime() {
      if (!this.form.break_end_time) return null;

      // Convert HH:MM format to time object
      const [hours, minutes] = this.form.break_end_time.split(':');
      return {
        hours: parseInt(hours, 10),
        minutes: parseInt(minutes, 10)
      };
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return ''
      // format as YYYY-MM-DD
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    handleTimeChange(timeValue, keyName) {
      if (timeValue) {
        const hours = String(timeValue.hours).padStart(2, '0');
        const minutes = String(timeValue.minutes).padStart(2, '0');
        const timeString = `${hours}:${minutes}`;
        this.$emit('change', { field: keyName, value: timeString });
      } else {
        this.$emit('change', { field: keyName, value: '' });
      }
    },
    handleDateChange(dateValue) {
      if (dateValue) {
        const formattedDate = this.$moment(dateValue).format('YYYY-MM-DD');
        this.$emit('change', {field: 'task_date', value: formattedDate});
      } else {
        this.$emit('change', { field: 'task_date', value: '' });
      }
    }
  }
}
</script>

<style scoped>
.base { position: fixed; top: 0; left: 0; right: 0; display: flex; justify-content: center; margin-top: 50px; }
.overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: gray; opacity: 0.5; }
.content { background-color: white; position: relative; border-radius: 10px; padding: 40px; }
.spinner-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); z-index: 9999; display: flex; justify-content: center; align-items: center; }
.spinner { border: 4px solid #f3f3f3; border-top: 4px solid #3498db; border-radius: 50%; width: 40px; height: 40px; animation: spin 2s linear infinite; }
@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
</style>